import { ActionType } from '../../actions/ActionType';
import { Action } from '../../actions/gift/learningPointMaintainActions';

export interface LearningPointMaintainState {
    isLoading: boolean;
    error: string | null;
    learningPointMaintain: {
        seq: number;
        memNo: string;
        pointsDate: string;
        typeNo: string;
        typeDesc: string;
        points: number;
        expDate: string;
    }[];
    pointTypeList: {
        typeNo: string;
        typeDesc: string;
    }[],
    memberPoints: number;
}

const initialState = {
    isLoading: false,
    error: null,
    learningPointMaintain: [],
    pointTypeList: [],
    memberPoints: 0,
};

const learningPointMaintainReducer = (
    state: LearningPointMaintainState = initialState,
    action: Action
) => {
    switch (action.type) {
        case ActionType.FETCH_LEARNING_POINT_MAINTAIN_LIST_START:
            return {
                isLoading: true,
                error: null,
                learningPointMaintain: state.learningPointMaintain,
                pointTypeList: state.pointTypeList,
                memberPoints: state.memberPoints,
            };
        case ActionType.FETCH_LEARNING_POINT_MAINTAIN_LIST_SUCCESS:
            return {
                isLoading: false,
                error: null,
                learningPointMaintain: action.payload,
                pointTypeList: state.pointTypeList,
                memberPoints: state.memberPoints,
            };
        case ActionType.FETCH_LEARNING_POINT_MAINTAIN_LIST_ERROR:
            return {
                isLoading: false,
                error: action.payload,
                learningPointMaintain: state.learningPointMaintain,
                pointTypeList: state.pointTypeList,
                memberPoints: state.memberPoints,
            };
        case ActionType.FETCH_POINT_TYPE_LIST_START:
            return {
                isLoading: true,
                error: null,
                learningPointMaintain: null,
                pointTypeList: state.pointTypeList,
                memberPoints: state.memberPoints,
            };
        case ActionType.FETCH_POINT_TYPE_LIST_SUCCESS:
            return {
                isLoading: false,
                error: null,
                learningPointMaintain: null,
                pointTypeList: action.payload,
                memberPoints: state.memberPoints,
            };
        case ActionType.FETCH_POINT_TYPE_LIST_ERROR:
            return {
                isLoading: false,
                error: action.payload,
                learningPointMaintain: null,
                pointTypeList: state.pointTypeList,
                memberPoints: state.memberPoints,
            };
        case ActionType.FETCH_MEMBER_POINTS_START:
            return {
                isLoading: true,
                error: null,
                learningPointMaintain: state.learningPointMaintain,
                pointTypeList: state.pointTypeList,
                memberPoints: 0,
            };
        case ActionType.FETCH_MEMBER_POINTS_SUCCESS:
            return {
                isLoading: false,
                error: null,
                learningPointMaintain: state.learningPointMaintain,
                pointTypeList: state.pointTypeList,
                memberPoints: action.payload,
            };
        case ActionType.FETCH_MEMBER_POINTS_ERROR:
            return {
                isLoading: false,
                error: action.payload,
                learningPointMaintain: state.learningPointMaintain,
                pointTypeList: state.pointTypeList,
                memberPoints: 0,
            };
        default:
            return state;
    }
};

export default learningPointMaintainReducer;